<template>
  <div>
    <div class="d-flex">
      <div class="pe-3" v-if="showMinMaxValues">
        <span class="text-muted">{{ bounds[0] }}<span v-if="percentage">%</span></span>
      </div>
      <div class="flex-grow-1 pt-1">
        <VueSlider :min="bounds[0]" :max="bounds[1]" :interval="interval" :modelValue="sliderValue" :tooltip="'always'"
                   :tooltip-placement="'top'" :tooltip-formatter="formatter" @change="changeValue"
                   @drag-end="submitChange" :drag-on-click="true"/>
      </div>
      <div class="ps-3" v-if="showMinMaxValues">
        <span class="text-muted">{{ bounds[1] }}<span v-if="percentage">%</span></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import naja from 'naja';
import {defineComponent, PropType, ref} from 'vue';
import VueSlider from 'vue-slider-component';

export default defineComponent({
    components: {VueSlider},
    props: {
        bounds: {
            type: Array as PropType<number[]>,
            required: true,
        },
        changeUrl: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        },
        interval: {
            type: Number,
            required: true,
        },
        percentage: {
            type: Boolean,
            default: false,
        },
        showMinMaxValues: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const sliderValue = ref(props.value);
        const lastSubmitValue = ref(props.value);
        const formatter = ref(props.percentage ? '{value}%' : '{value}');

        function changeValue(value: number): void {
            sliderValue.value = value;
        }

        function submitChange(): void {
            if (lastSubmitValue.value === sliderValue.value) {
                return;
            }

            naja.makeRequest('POST', props.changeUrl, {value: JSON.stringify(sliderValue.value)})
                .then(() => lastSubmitValue.value = sliderValue.value);
        }

        return {sliderValue, formatter, changeValue, submitChange};
    },
});
</script>
